<template lang="html">
    <div id="account">
        <header>
            Payment details
            <router-link :to="{ name: 'Account' }"
                ><chevron-left-icon class="icon"></chevron-left-icon
            ></router-link>
        </header>

        <form class="form" @submit.prevent="">
            <!--<div class="formGroup">
                <label>Subscription type</label>
              <input type="text" v-model="form.type">
          </div>

          <div class="formGroup">
                <label>Monthly cost</label>
              <input type="text" v-model="form.cost">
          </div>

          <div class="formGroup">
                <label>Subscription renewal date</label>
              <input type="text" v-model="form.renewal">
          </div>
          -->

            <div class="formGroup" v-if="passwordOpen & !cardOpen">
                <label>Please enter your password</label>
                <password-input v-model="form.password" />
            </div>

            <div class="formGroup" v-if="passwordOpen & !cardOpen">
                <button
                    @click.prevent="checkPassword"
                    :disabled="form.busy || form.password == ''"
                    class="button"
                    type="button"
                    name="button"
                >
                    Submit
                </button>
            </div>

            <div class="formGroup" v-if="!cardOpen && !passwordOpen">
                <label>Payment method used for in app purchases</label>
                <input disabled type="text" v-model="card_last4" />
            </div>

            <div class="form-group" v-if="!cardOpen && !passwordOpen">
                <button
                    @click.prevent="passwordOpen = true"
                    class="button"
                    :disabled="form.busy"
                    type="submit"
                    name="button"
                >
                    {{ form.busy ? "Please wait..." : "Update payment method" }}
                </button>
            </div>

            <div v-show="cardOpen">
                <div class="formGroup">
                    <label>Name on card</label>
                    <input type="text" v-model="form.name" />
                </div>
                <div class="formGroup" v-show="form.name !== ''">
                    <div class="card" ref="card"></div>
                </div>

                <div class="formGroup" v-show="form.name !== ''">
                    <button
                        class="button"
                        :disabled="busy"
                        @click.prevent="updateCardDetails"
                        type="button"
                        name="button"
                    >
                        {{ busy ? "Please wait..." : "Update card details" }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import PasswordInput from "@/components/App/password-input";
import { Form } from "vform";
import { ChevronLeftIcon } from "vue-feather-icons";
export default {
    name: "subscription",
    components: { PasswordInput, ChevronLeftIcon },
    mounted() {
        this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY);
        var elements = this.stripe.elements();
        this.card = elements.create("card");
        this.card.mount(this.$refs.card);
    },
    data() {
        return {
            stripe: "",
            card: "",
            busy: false,
            cardOpen: false,
            passwordOpen: false,
            form: new Form({
                password: "",
                client_secret: "",
                name: "",
                payment_method: "",
            }),
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        card_last4: {
            get() {
                return "**** **** **** **** " + this.user.stripe_card;
            },
            set() {},
        },
    },
    methods: {
        cancel() {
            this.$notify("To cancel your subscription please visit the app store");
        },

        updateCardDetails() {
            this.busy = true;
            this.form.get("authed/stripe/intent").then((response) => {
                this.form.client_secret = response.data.client_secret;

                this.stripe
                    .confirmCardSetup(this.form.client_secret, {
                        payment_method: {
                            card: this.card,
                            billing_details: {
                                name: this.form.name,
                            },
                        },
                    })
                    .then((result) => {
                        this.busy = false;
                        if (result.error) {
                            this.$notify({
                                type: "error",
                                text: result.error.message,
                            });
                        } else {
                            this.completeSetup(result.setupIntent.payment_method);
                        }
                    });
            });

            /*
      this.form.put('/user/'+this.user.id).then((user)=>{
          this.$store.dispatch('updateUser',user.data);
          this.$notify({
            duration: 1000,
            text: 'Your details have been updated'
          });
      });

      */
        },
        checkPassword() {
            this.form.post("/password-check").then((response) => {
                if (response.data) {
                    this.passwordOpen = false;
                    this.cardOpen = true;
                } else {
                    this.$notify({
                        text: "your password could not be verified",
                        type: "error",
                    });
                }
            });
        },
        completeSetup($method) {
            this.form.payment_method = $method;
            this.$notify("Your payment method has been updated");
            this.form.post("/stripe/update-card-details").then((response) => {
                this.$store.state.user.stripe_card = response.data.stripe_card;
                this.busy = false;
                this.form.client_secret = "";
                this.form.name = "";
                this.form.payment_method = "";
                this.cardOpen = false;
            });

            // Makes call to the server to save card payment details

            // Redirect to home
        },
    },
};
</script>

<style lang="scss" scoped>
.card {
    width: 100%;
    background: #e7efeb;
    border: 0px;
    padding: 20px;
    border-radius: 12px;
    font-size: 1rem;
    font-family: canada-type-gibson, sans-serif;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: #267962;
    max-width: 100%;
    min-width: 100%;
}
</style>
